import React, { useState, useEffect } from "react";
import DepartureReportTable from "../common/tables/DepartureReportTable";
import { filter } from "lodash";
import store from "../../store/Store";

function DepartureReport() {
	const [getOutCounterData, setGetOutCounterData] = useState({
		GateOut: "",
		TotalGateOut: "",
	});

	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Departure Report", View: 1 }).length > 0
		) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Departure Report", View: 1 })
			);
		}
	}, [userData]);

	return (
		<>
			<div className="df_arrivalDepartureCounter">
				<div className="flex-row mb-12">
					<h1>Departure Report</h1>
				</div>
				<div className="count-container-Gate-In-Out">
					<div className="counter approved">
						Total
						<span className="count approved-count">
							{getOutCounterData.TotalGateOut.length}
						</span>
					</div>
				</div>
				<div className="count-container-Gate-In-Out">
					<div className="counter pending">
						Gate Out
						<span className="count pending-count">
							{getOutCounterData.GateOut.length}
						</span>
					</div>
				</div>
			</div>
			<DepartureReportTable
				setGetOutCounterData={setGetOutCounterData}
				filteredUserAccessData={filteredUserAccessData}
			/>
		</>
	);
}
export default DepartureReport;
